<template>
<div class="container-fluid d-flex flex-column">
  <div class="bible-open-head">
  </div>
  <div class="row no-gutters bible-open-body">
    <div role="tablist" class="w-100">
      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1 px-3" role="tab">
          <b-link href="#" v-b-toggle.auth-accordion-1>サインイン</b-link>
        </b-card-header>
        <b-collapse id="auth-accordion-1" visible accordion="auth-accordion" role="tabpanel">
          <b-card-body>
            <b-form @submit="signin" class="w-100" ref="form">
              <b-form-group
                label="メールアドレス">
                <input
                  class="form-control"
                  type="text"
                  v-model="form.email"
                  placeholder="入力してください">
                <base-error-feedback :errors="errors.email"></base-error-feedback>
              </b-form-group>
              <b-form-group
                label="パスワード">
                <base-togglable-password
                  v-model="form.password"
                  placeholder="入力してください"
                  />
                <base-error-feedback :errors="errors.password"></base-error-feedback>
              </b-form-group>
              <b-form-group
                class="mb-4"
                label="">
                <b-button type="submit" variant="primary" class="w-100">サインイン</b-button>
              </b-form-group>
            </b-form>

            <a href="https://manual.si.jbsbibleapp.com/terms.html" target="_blank">
                利用規約<br>
                プライバシーポリシー<br>
                特定商取引法所定の記載事項
            </a>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1 px-3" role="tab">
          <b-link href="#" v-b-toggle.auth-accordion-2>パスワード紛失</b-link>
        </b-card-header>
        <b-collapse id="auth-accordion-2" accordion="auth-accordion" role="tabpanel">
          <b-card-body>
            <b-form @submit="forgetPassword" class="w-100" ref="form" autocomplete="new-password">
              <b-form-group
                label="メールアドレス">
                <input
                  class="form-control"
                  type="text"
                  v-model="form.email"
                  placeholder="入力してください">
                <base-error-feedback :errors="errors.email"></base-error-feedback>
              </b-form-group>
              <b-form-group
                label="新しいパスワード">
                <base-togglable-password
                  v-model="form.password"
                  placeholder="入力してください"
                  />
                <base-error-feedback :errors="errors.password"></base-error-feedback>
              </b-form-group>
              <b-form-group
                class="mb-4"
                label="">
                <b-button type="submit" variant="primary" class="w-100">パスワード変更を申請</b-button>
              </b-form-group>
            </b-form>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1 px-3" role="tab">
          <b-link href="#" v-b-toggle.auth-accordion-3>アカウント作成</b-link>
        </b-card-header>
        <b-collapse id="auth-accordion-3" accordion="auth-accordion" role="tabpanel">
          <b-card-body>
            <b-button :href="$store.state.env.VUE_APP_REGISTER_BASE_URL" target="_blank" variant="primary" class="w-100 text-white">アカウント作成ページへ</b-button>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>


  </div>
</div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        email: '',
        password: '',
      },
      errors: {
      },
    }
  },
  computed: {
  },
  methods: {
    signin (event) {
      event.preventDefault()
      this.errors = {}
      this.$store.dispatch('authSignin', this.form).then(() => {
      }).catch((error) => {
        this.errors = error.response.data.errors
      })
    },
    forgetPassword (event) {
      event.preventDefault()
      this.errors = {}
      this.$store.dispatch('authForgetPassword', this.form).then(() => {
      }).catch((error) => {
        this.errors = error.response.data.errors
      })
    },
  },
  created: function() {
  },
  async mounted () {
    this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
      if (collapseId.match(/auth-accordion-*/)) {
        this.form = {}
        this.errors = {}
      }
    })
  },
  beforeDestroy: function () {
  }
}
</script>

<style lang="scss">
</style>
